/**
 * 销毁动画
 *
 * @export
 * @param {
*  Ref  动画ref
* }
*/
export default function destoryAnimation(Ref) {
  if (!Ref) return
  if (Ref.current) Ref.current.destroy()
}